export function getSummaryAvailability(bookingType, staffs = [], user = {}) {
  const assignments = bookingType?.assignedStaffs || [];
  const preferred = assignments.find(assignment => {
    const staff = staffs.find(item => Number(item.id) === Number(assignment.staffId));
    return staff && (Number(staff.id) === Number(user.staffId) || Number(staff.user?.id) === Number(user.userId));
  });
  const ordered = preferred ? [preferred, ...assignments.filter(item => item !== preferred)] : assignments;
  for (const assignment of ordered) {
    const staff = staffs.find(item => Number(item.id) === Number(assignment.staffId));
    const group = staff?.workingHourGroups?.find(item => Number(item.id) === Number(assignment.groupId));
    if (group) return { staff, group };
  }
  return {};
}
